import { createActionGroup, props } from '@ngrx/store';
import { CampaignType, CreateValueChainMutation, DeleteValueChainMutation, DownloadActivityValueChainMutation, GetActivityValueChainCampaignsQuery, GetActivityValueChainQuery, UpdateActivityValueChainMutation } from '../../../../graphql-planner-tool/generated';

export const ActivityValueChainActions = createActionGroup({
  source: 'ActivityValueChain/API',
  events: {
    "Load Value Chains": props<{ parameters: any, campaignId: string }>(),
    "Load Value Chains Success": props<{ valueChains: GetActivityValueChainQuery['activityValueChains'] }>(),
    "Load Value Chains Failure": props<{ error: any }>(),

    "Load All Value Chains": props<{ parameters: any, campaignId: string }>(),
    "Load All Value Chains Success": props<{ valueChains: GetActivityValueChainQuery['activityValueChains'] }>(),
    "Load All Value Chains Failure": props<{ error: any }>(),

    "Load Campaigns": props<{ campaignType: CampaignType }>(),
    "Load Campaigns Success": props<{ campaigns: GetActivityValueChainCampaignsQuery['campaignsByType'] }>(),
    "Load Campaigns Failure": props<{ error: any }>(),

    "Update Activity Value Chain": props<{ category: string, id: string, macroCategory: string, categoryDescription: string, viewOrder: number }>(),
    "Update Activity Value Chain Success": props<{ update: UpdateActivityValueChainMutation['updateValueChain'] }>(),
    "Update Activity Value Chain Failure": props<{ error: any }>(),

    "Delete Activity Value Chain": props<{ id: string, parameters: any, campaignId: string }>(),
    "Delete Activity Value Chain Success": props<{ delete: DeleteValueChainMutation['deleteValueChain'] }>(),
    "Delete Activity Value Chain Failure": props<{ error: any }>(),

    "Create Activity Value Chain": props<{ parameters: any, campaignId: string, category: string, macroCategory: string, categoryDescription: string }>(),
    "Create Activity Value Chain Success": props<{ delete: CreateValueChainMutation['createNewValueChain'] }>(),
    "Create Activity Value Chain Failure": props<{ error: any }>(),

    "Download Activity Value Chain": props<{ campaignId: string, parameters: any }>(),
    "Download Activity Value Chain Success": props<{ download: DownloadActivityValueChainMutation['downloadActivityValueChainExcel'] }>(),
    "Download Activity Value Chain Failure": props<{ error: any }>()
  }
});
